import banImg1 from "../../assets/images/services/data-classification/dataclass-banner.webp";
import banImg2 from "../../assets/images/services/data-classification/dataclass-intro.webp";
import features01 from "../../assets/images/services/data-classification/dataclass-featu-01.webp"
import features02 from "../../assets/images/services/data-classification/dataclass-featu-02.webp"
import features03 from "../../assets/images/services/data-classification/dataclass-featu-03.webp"
import features04 from "../../assets/images/services/data-classification/dataclass-featu-04.webp"
import features05 from "../../assets/images/services/data-classification/dataclass-featu-05.webp"
import features06 from "../../assets/images/services/data-classification/dataclass-featu-06.webp"
import features07 from "../../assets/images/services/data-classification/dataclass-featu-07.webp"
import features08 from "../../assets/images/services/data-classification/dataclass-featu-08.webp"

const DataClassificationPlatformData = {
    "BannerData":[
        {
            "title": "Efficient <span>Data Classification<br/></span> Platform",
            "bannerBtnText": 'Let’s Connect',
            "bannerBigimg" : `${banImg1}`,
            "bannerAlt": 'Android App Development',
        },
    ],

    "Introduction":[
        {
            "introContent" :`Our Data Classification Platform empowers organizations to organize, manage, and protect their data assets effectively. By categorizing data based on sensitivity and relevance, our platform enhances data visibility, compliance, and security. Whether you're dealing with structured or unstructured data, our scalable solution simplifies data governance and reduces risks.`,
            "introImg": `${banImg2}`,
            "brochurelink": "/",
        }
    ],

    "ServiceBenifits" : [
        {   
            "benifitCont" : "Organize data assets for improved accessibility and efficiency",
        },
        {
            "benifitCont" : "Enhance data governance and compliance",
        },
        {
            "benifitCont" : "Reduce risks associated with data breaches and unauthorized access",
        },
        {
            "benifitCont" : "Streamline data workflows and collaboration",
        },
        {
            "benifitCont" : "Empower decision-making with accurate data classification",
        },
        {
            "benifitCont" : "Maintain data integrity and consistency",
        },
        // {
        //     "benifitCont" : "Receive continuous support and updates for evolving data challenges",
        // },
    ],

    "FeaturesServices":[
        {
          
            "featureDescriptiom":"Automated data discovery and classification algorithms",
            "FeatImg" : `${features01}`,
            "FeatImgAltTag" : "Native Android Apps",
            
        },
        {
            
            "featureDescriptiom":"Customizable classification rules and policies",
            "FeatImg" : `${features02}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"Metadata tagging and labeling for easy identification",
            "FeatImg" : `${features03}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"Integration with data management tools and workflows",
            "FeatImg" : `${features04}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"Role-based access controls and permissions",
            "FeatImg" : `${features05}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"Reporting and analytics for data insights",
            "FeatImg" : `${features06}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"Compliance tracking and audit trails",
            "FeatImg" : `${features07}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"Scalable architecture for growing data needs",
            "FeatImg" : `${features08}`,
            "FeatImgAltTag" : "Web Apps",
        },
       
    ],


    "FooterCtaSection":[
        {
            "CtaDescriptiom":"Take control of your data with our advanced Classification Platform. Contact us today to schedule a demo and discover how our solution can revolutionize your data management.",
            "CtaBtnText": 'Let’s Connect',
            "CtaBtnLink": '/get-a-quote',
        },
    ],


    
} 

export default DataClassificationPlatformData